import { useLoaderData } from "@remix-run/react";
import { json } from "@remix-run/node";
import type { LoaderFunction } from "@remix-run/node";
import {
  MediaHome,
  EventsHome,
  // HowItWork,
  FachArticleHome,
  InfoCardsMerged,
  PartnersLogos,
} from "~/screens";

import {
  // fetchThemenschwerpunkteListItem,
  FetchPartnerData,
  getchHomePageData,
} from "~/api";
import config from "~/config.server";
import { Section } from "~/layout/section";

export const loader: LoaderFunction = async ({ context, request }) => {
  // const url = new URL(request.url);

  // const {
  //   teamMembers,
  //   inklusionCards,
  //   recomendationSection,
  //   infoSection,
  //   media,
  // } = await fetchThemenschwerpunkteListItem();

  const { mediaPartners, cooperationPartners } = await FetchPartnerData();
  const {
    media: mediaData,
    specialistArticles,
    thematicFoci,
  } = await getchHomePageData();

  const cards = [
    {
      anchor: "https://ueber.ru-digital.de/",
      description: "Erfahre mehr über das Projekt und das Team.",
      id: 0,
      title: "Über ru-digtal:",
      icon: "cursor-information",
    },
    {
      anchor: "https://explore.ru-digital.de/fragen-und-anworten/",
      description:
        "Erhalte Hilfe bei der Nutzung von ru-digital oder dem rechtssicheren Einsatz von Medien.",
      id: 1,
      title: "Hilfecenter",
      icon: "newspaper-fold",
    },
    {
      anchor: "https://blog.ru-digital.de/",
      description: "Informiere dich über aktuelle Entwicklungen.",
      id: 2,
      title: "NewsBlog lesen",
      icon: "mail-advertising-envelope",
    },
    {
      anchor: "https://join.ru-digital.de",
      description: "Entdecke Möglichkeiten das Projekt zu unterstützen.",
      id: 3,
      title: "ru-digital unterstützen",
      icon: "support",
    },
    {
      anchor: " https://docs.ru-digital.de/",
      description:
        "Erhalte Hilfe bei der Nutzung von ru-digital oder dem rechtssicheren Einsatz von Medien",
      id: 4,
      title: "Hilfecenter",
      icon: "help-wheel",
    },
  ];
  let theme = thematicFoci.map((item: any) => {
    return {
      ...item,
      // finalUrl: config.BASEURL + item.picture.file.url,
    };
  });
  return json(
    {
      mediaData,
      cards,
      thematicFoci: theme,
      specialistArticles: specialistArticles,
      mediaPartners,
      cooperationPartners,
      baseUrl: config.BASEURL,
    },
    {
      headers: {
        // max-age controls the browser cache
        // s-maxage controls a CDN cache
        "Cache-Control": "public, max-age=30, s-maxage=86400",
      },
    }
  );
  // return redirect("/themenschwerpunkte");
};
// export const meta: V2_MetaFunction<typeof loader> = ({ data }) => {
//   console.log("========data homee", data);
//   return [
//     { title: "themenschwerpunkte" },
//     // {
//     //   property: "og:title",
//     //   content: data.name,
//     // },
//     // {
//     //   name: "description",
//     //   content: data.description,
//     // },
//   ];
// };
export default function Home() {
  // const location = useLocation();
  const {
    mediaData,
    cards,
    thematicFoci,
    specialistArticles,
    cooperationPartners,
    mediaPartners,
    baseUrl,
  } = useLoaderData<{
    mediaData: Array<any>;
    specialistArticles: Array<any>;
    cards: any;
    thematicFoci: Array<any>;
    mediaPartners: Array<any>;
    cooperationPartners: Array<any>;
    baseUrl: string;
  }>();
  // console.log("🚀 ~ loader ~ specialistArticles:", specialistArticles);
  return (
    <div className="flex h-full flex-col">
      <div className="mt-4 md:mt-8">
        <MediaHome thematicFoci={thematicFoci} mediaData={mediaData} />
      </div>
      <div className="mt-8">
        <FachArticleHome articleData={specialistArticles} />
      </div>
      <div className="mt-8">
        <EventsHome />
      </div>
      <div className="mt-8">
        <InfoCardsMerged
          cards={cards}
          title="ru-digital: mehr als nur ein Medienguide"
          body="<p>ru-digital unterstützt Lehrkräfte dabei, digitale Medien und Inhalte gezielt für den Religionsunterricht zu nutzen – kuratiert, strukturiert und praxisnah. Statt in der Materialfülle zu versinken, findest du bei uns geprüfte Angebote, die thematisch eingeordnet sind und durch didaktisch-methodische Hinweise ergänzt werden. Das spart Zeit, schafft Sicherheit und macht Unterrichtsvorbereitung planbar.
Im Mittelpunkt steht die Passung: Medien werden nicht nur verlinkt, sondern so erschlossen, dass sie im Unterricht wirklich funktionieren – mit Blick auf Fragestellungen, Kompetenzen, Zugänge und mögliche Lernwege. Ob Einstieg, Vertiefung, Gesprächsanlass, kreative Verarbeitung oder digitale Lernaufgabe: ru-digital hilft dir, aus digitalen Ressourcen tragfähige Unterrichtsbausteine zu machen. Such- und Filtermöglichkeiten sowie Merken, Sammeln und Kombinieren unterstützen dabei einen klaren Workflow – vom Finden bis zur Umsetzung.
Mit der neuen Version ist ru-digital mehr als eine Mediendatenbank: Du findest auch eine wachsende Sammlung an Fachbeiträgen zur eigenen Weiterbildung und zur inhaltlichen Vertiefung sowie einen Überblick über Veranstaltungen und Fortbildungen. Unter rudi.themen bündeln wir zentrale Inhalte in ausführlichen Themendossiers: kompakt zum Einstieg, fundiert zur Vertiefung und mit konkreten Impulsen für die Unterrichtspraxis.
Ein besonderes Plus ist der rudi.guide: digitale Arbeitspläne, die dich Schritt für Schritt durch Planung und Durchführung führen – mit klaren Lernzielen, passenden Materialien und methodischen Vorschlägen. Die Guides sind so gestaltet, dass sie auch im konfessionell-kooperativen Religionsunterricht gut einsetzbar sind und unterschiedliche Perspektiven produktiv ins Gespräch bringen. So wird aus Recherche ein roter Faden – und aus digitalen Angeboten guter Unterricht, der zu deiner Lerngruppe passt.</p>"
        />
      </div>
      <div className="mt-8">
        <Section>
          <h3 className="text-2xl font-bold text-textColor-primary lg:text-[40px]">
            Partner & Unterstützer
          </h3>
          <p className="my-1 mt-2 max-w-lg text-base leading-relaxed text-textColor-primary">
            Gemeinsam mit Partnern und Unterstützern verfolgen wir das Ziel, mit
            ru-digital Lehrkräften ein Referenzportal für den katholischen
            Religionsunterrichts zu bieten.
          </p>
        </Section>
        <PartnersLogos
          cards={cooperationPartners}
          title="Kooperationspartner"
          baseUrl={baseUrl}
        />
      </div>
      <div className="mt-2">
        <PartnersLogos
          cards={mediaPartners}
          // subititle="Gemeinsam mit Partnern und Unterstützern verfolgen wir das Ziel, mit ru-digital Lehrkräften ein Referenzportal für den katholischen Religionsunterrichts zu bieten."
          title="PARTNER"
          baseUrl={baseUrl}
        />
      </div>
    </div>
  );
}
